import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/home.vue'
import Login from '../views/login.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/404',
    component: () => import('@/views/404'),
    hidden: true
  },
  {
    path: '/',
    name: 'home',
    component: Home
  },
  {
    path: '/login',
    name: 'login',
    component: Login
  },
  {
    path: '/user',
    component: () => import('@/views/user/index'),
    redirect: '/system/user/detail',
    name: 'user',
    meta: { title: '用户管理' },
    children: [
      {
        path: 'detail',
        component: () => import('@/views/user/detail'),
        name: 'userdetail',
        meta: { title: '用户详情' }
      }
    ]
  }
]

export const asyncRoutes = [
  {
    path: '/dms',
    name: 'dms',
    meta: { title: '版本管理'
      // auths: [{
      //   level: 1, // level为1到4，用于区分权限到哪一级
      //   code: '04'
      // }]
    },
    component: () => import('@/views/dms/index'),
    redirect: '/dms/version',
    children: [
      {
        path: 'version',
        component: () => import('@/views/dms/versionLine'),
        name: 'version',
        meta: { title: '历史版本' }
      },
      {
        path: 'manage',
        component: () => import('@/views/dms/manage'),
        name: 'manage',
        meta: { title: '版本管理',
          auths: [{
            level: 4,
            code: '04000200'
          }]
        }
      }
    ]
  },
  {
    path: '/manage',
    component: () => import('@/views/manage/index'),
    redirect: '/manage/auth',
    name: 'manage',
    meta: { title: '系统管理',
      auths: [{
        level: 1,
        code: '01'
      }]
    },
    children: [
      {
        path: 'auth',
        component: () => import('@/views/manage/auth'),
        name: 'auth',
        meta: { title: '权限管理', keepAlive: true }
      },
      {
        path: 'authEdit',
        component: () => import('@/views/manage/authEdit'),
        name: 'authEdit',
        meta: { title: '分配权限' }
      }
    ]
  },
  {
    path: '/open',
    component: () => import('@/views/manage/index'),
    name: 'open',
    redirect: '/open/apimanage',
    meta: { title: 'api管理',
      auths: [{
        level: 1,
        code: '07'
      }]
    },
    children: [
      {
        path: 'instruction',
        component: () => import('@/views/manage/instruction'),
        name: 'instruction',
        meta: {
          title: '使用说明'
        }
      },
      {
        path: 'apimanage',
        component: () => import('@/views/manage/apimanage'),
        name: 'apimanage',
        meta: {
          title: 'API管理'
        }
      },
      {
        path: 'addapi/:from',
        component: () => import('@/views/manage/addapi'),
        name: 'addapi',
        meta: {
          title: '添加API'
        }
      }
    ]
  },
  {
    path: '/iplugin',
    name: 'iplugin',
    meta: {
      title: '版本管理'
    },
    component: () => import('@/views/iplugin/index'),
    redirect: '/iplugin/version',
    children: [
      {
        path: 'version',
        component: () => import('@/views/iplugin/versionLine'),
        name: 'iversion',
        meta: { title: '历史版本' }
      },
      {
        path: 'manage',
        component: () => import('@/views/iplugin/manage'),
        name: 'imanage',
        meta: { title: '版本管理',
          auths: [{
            level: 4,
            code: '05000200'
          }]
        }
      }
    ]
  },
  { path: '*', redirect: '/404', hidden: true }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
